﻿import $ from "jquery";
import "bootstrap";
import { GuiDetailGeneric } from "../../GuiDetailGeneric";
import { IToast } from "../../Interface/IToast"
import { Chart } from "../../chart-setup";
import { IChartData } from "../../Interface/IChartData";
export class GuiDetailAdb extends GuiDetailGeneric {

    constructor() {
        super("Adb");

        //this.updateAuftragnehmerControl();
        this.setBefoerderer();
        this.drawChartAktionen();
    }

    // DEVCLR-337: Aktionen je Monat (letzte 12 Monate) als Balkendiagramm im Tab "Aktion"
    private drawChartAktionen() {
        const ctx = document.getElementById("chartAdbAktionen") as HTMLCanvasElement | null;
        const input = document.getElementById("jsonChartAdbAktionen") as HTMLInputElement | null;
        if (ctx == null || input == null || input.value === "" || input.value === "null") {
            return;
        }
        const chartData = JSON.parse(input.value) as IChartData;
        // Skala oben immer +1, damit die Balken nicht anstoßen; Farbe $green2 (heller als Speichern-Button $green3)
        const max = Math.max(0, ...chartData.values) + 1;
        new Chart(ctx, {
            type: "bar",
            data: { labels: chartData.labels, datasets: [{ label: "Aktionen je Monat", data: chartData.values, backgroundColor: "#0CAD8E" }] },
            options: { responsive: true, maintainAspectRatio: false, animation: false, plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, max: max, ticks: { precision: 0 } } } }
        });
    }

    attachEvents() {
        this.log("attachEvents");
        super.attachEvents();

        $("#btnAdbAddPosition").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnAdbAddKostenverteilung").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));

        // Control Events
        $("#VmDetail_AbfallId").on("change", () => this.changeAbfall());
        //$("#VmDetail_AuftragnehmerAbweichend").on("change", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.changeAuftragnehmerAbweichende(e));
        //$("#VmDetail_GewerblicherSiedlungsabfall").on("change", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.changeGewerblicherSiedlungsabfall(e));

        $("#VmDetail_EntsorgungsnachweisId").on("change", () => this.changeEntsorgungsnachweis());


        // Aval
        $("#btnCreateAvalMatching").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnDeleteAvalMatching").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnSendAvalMatching").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnCancelAvalMatching").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnAddMatching").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));
        $("#btnSendMatched").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickActionButton(e));


        $("#detailForm").submit((parameters: JQuery.SubmitEvent) => { this.beforeSubmit(parameters); });

        $("div#divRbTurnus input:radio").on("change", (e: JQuery.ChangeEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.changeTurnus(e));
        $("input:radio[name='VmDetail.AdbTurnus.DailyTyp']").on("change", () => this.changeDailyTyp());
        $("input:radio[name='VmDetail.AdbTurnus.MonthlyTyp']").on("change", () => this.changeMonthlyTyp());
        $("input:radio[name='VmDetail.AdbTurnus.YearlyTyp']").on("change", () => this.changeYearlyTyp());

        this.showTurnus();

        $("input:radio[name='VmDetail.AutomatikTyp']").on("change", () => this.changeAutomatik());

    }

    changeAutomatik() {
        this.log("changeAutomatik");
        this.alterAutomatik();
    }

    alterAutomatik() {
        this.log("alterAutomatik");
        const rb = $("input:radio[name='VmDetail.AutomatikTyp']:checked");
        if (rb.val() === "0") // Keine
        {
            $("#VmDetail_AuftragnehmerId").attr("disabled", "disabled");
        }
        if (rb.val() === "1") // Email
        {
            $("#VmDetail_AuftragnehmerId").removeAttr("disabled");
        }
        if (rb.val() === "2") // AVAL
        {
            $("#VmDetail_AuftragnehmerId").attr("disabled", "disabled");
        }

    }


    changeTurnus(e: JQuery.ChangeEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("changeTurnus");

        // Vorbelegung Radio und Daten in Turnus
        const rb = $(e.currentTarget)[0];
        const id = rb.id;
        $("div#rowStartDatum").addClass("d-none");

        if (id === "Daily") {
            $("div#rowStartDatum").removeClass("d-none");
            if ($("input[name='VmDetail.AdbTurnus.DailyTyp']:checked").length === 0) {
                $("#DailyTyp1").attr("checked", "checked");
                $("input[name='VmDetail.AdbTurnus.DailyDays']").val("1");
            }
        }

        if (id === "Weekly") {
            $("div#rowStartDatum").removeClass("d-none");
            if ($("input[name='VmDetail.AdbTurnus.WeeklyTyp']:checked").length === 0) {
                $("#WeeklyTyp1").attr("checked", "checked");
                $("input[name='VmDetail.AdbTurnus.WeeklyWeeks']").val("1");
            }
        }

        if (id === "Monthly") {
            $("div#rowStartDatum").removeClass("d-none");
            if ($("input[name='VmDetail.AdbTurnus.MonthlyTyp']:checked").length === 0) {
                $("#MonthlyTyp1").attr("checked", "checked");
                $("input[name='VmDetail.AdbTurnus.MonthlyDay']").val("1");
                $("input[name='VmDetail.AdbTurnus.MonthlyMonth']").val("1");
            }
        }

        if (id === "Yearly") {
            $("div#rowStartDatum").removeClass("d-none");
            if ($("input[name='VmDetail.AdbTurnus.YearlyTyp']:checked").length === 0) {
                $("#YearlyTyp1").attr("checked", "checked");
                $("input[name='VmDetail.AdbTurnus.YearlyDay']").val("1");
                $("input[name='VmDetail.AdbTurnus.YearlyMonth']").val("1");
            }
        }

        this.showTurnus();

    }

    changeDailyTyp() {
        this.log("changeDailyTyp");
        this.alterGuiDailyTyp();
    }

    alterGuiDailyTyp() {
        const rb = $("input:radio[name='VmDetail.AdbTurnus.DailyTyp']:checked");
        if (rb.val() === "1") {
            $("input:text[name='VmDetail.AdbTurnus.DailyDays']").removeAttr("disabled");
        } else {
            $("input:text[name='VmDetail.AdbTurnus.DailyDays']").attr("disabled", "disabled");
        }
    }

    changeMonthlyTyp() {
        this.log("changeMonthlyTyp");
        this.alterGuiMonthlyTyp();
    }

    alterGuiMonthlyTyp() {
        const rb = $("input:radio[name='VmDetail.AdbTurnus.MonthlyTyp']:checked");
        if (rb.val() === "1") {
            $("input:text[name='VmDetail.AdbTurnus.MonthlyDay']").removeAttr("disabled");
            $("input:text[name='VmDetail.AdbTurnus.MonthlyMonth']").removeAttr("disabled");

            $("select[name='VmDetail.AdbTurnus.MonthlyWeekdayCount']").attr("disabled", "disabled");
            $("select[name='VmDetail.AdbTurnus.MonthlyWeekday']").attr("disabled", "disabled");
            $("input:text[name='VmDetail.AdbTurnus.MonthlyMonth2']").attr("disabled", "disabled");

        } else {
            $("input:text[name='VmDetail.AdbTurnus.MonthlyDay']").attr("disabled", "disabled");
            $("input:text[name='VmDetail.AdbTurnus.MonthlyMonth']").attr("disabled", "disabled");

            $("select[name='VmDetail.AdbTurnus.MonthlyWeekdayCount']").removeAttr("disabled");
            $("select[name='VmDetail.AdbTurnus.MonthlyWeekday']").removeAttr("disabled");
            $("input:text[name='VmDetail.AdbTurnus.MonthlyMonth2']").removeAttr("disabled");

        }
    }


    changeYearlyTyp() {
        this.log("changeYearlyTyp");
        this.alterGuiYearlyTyp();
    }

    alterGuiYearlyTyp() {
        const rb = $("input:radio[name='VmDetail.AdbTurnus.YearlyTyp']:checked");
        if (rb.val() === "1") {
            $("input:text[name='VmDetail.AdbTurnus.YearlyDay']").removeAttr("disabled");
            $("select[name='VmDetail.AdbTurnus.YearlyMonth']").removeAttr("disabled");

            $("select[name='VmDetail.AdbTurnus.YearlyWeeklydayCount']").attr("disabled", "disabled");
            $("select[name='VmDetail.AdbTurnus.YearlyWeeklyday']").attr("disabled", "disabled");
            $("select[name='VmDetail.AdbTurnus.YearlyWeeklydayMonth']").attr("disabled", "disabled");

        } else {
            $("input:text[name='VmDetail.AdbTurnus.YearlyDay']").attr("disabled", "disabled");
            $("select[name='VmDetail.AdbTurnus.YearlyMonth']").attr("disabled", "disabled");

            $("select[name='VmDetail.AdbTurnus.YearlyWeeklydayCount']").removeAttr("disabled");
            $("select[name='VmDetail.AdbTurnus.YearlyWeeklyday']").removeAttr("disabled");
            $("select[name='VmDetail.AdbTurnus.YearlyWeeklydayMonth']").removeAttr("disabled");

        }
    }

    private showTurnus() {
        this.log("showTurnus");
        if ($("#tabAdbTurnus").length === 0) return;

        const rb = $("input[name='VmDetail.AdbTurnus.TurnusTyp']:checked")[0];
        const id = rb.id;
        const divRb = $(`div[data-rb='${id}']`);
        this.log(`changeTurnus id=${id}`);

        $("div[data-rb]").addClass("d-none"); // Alle ausblenden
        divRb.removeClass("d-none"); // passenden einblenden

        if (id === "None") {
            $("div#rowStartDatum").addClass("d-none");
        } else {
            $("div#rowStartDatum").removeClass("d-none");
        }

        this.alterGuiDailyTyp();
        this.alterGuiMonthlyTyp();
        this.alterGuiYearlyTyp();
    }


    private beforeSubmit(parameters: JQuery.SubmitEvent) {
        const isGewSiedlungsabfall = $("#VmDetail_GewerblicherSiedlungsabfall").is(":checked");
        const auswahl = $("#VmDetail_AbfallVerwertungId").val();
        if (isGewSiedlungsabfall && auswahl === "0") {
            const toast: IToast = {
                title: "Fehler", message: "Bitte ein Verfahren wählen", duration: 8000, level: "warning"
            };
            $("#VmDetail_AbfallVerwertungId").addClass("is-invalid");
            this.displayToast(toast);
            parameters.preventDefault();
            this.unlock();
            return false;
        }
        return true;
    }

    private changeAbfall() {
        this.log("changeAbfall");

        const gewSiedlungsabfalle = $("#VmDetail_AbfallId option:selected").data("data1");

        if (gewSiedlungsabfalle === "True") {
            $("#VmDetail_GewerblicherSiedlungsabfall").attr("checked", "checked");
        } else {
            $("#VmDetail_GewerblicherSiedlungsabfall").removeAttr("checked");
        }
    }

    //private changeGewerblicherSiedlungsabfall(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
    //    var isGewSiedlungasbfall = $("#VmDetail_GewerblicherSiedlungsabfall").is(":checked");
    //    if (isGewSiedlungasbfall) {
    //        $("#VmDetail_AbfallVerwertungId").attr("required", "required");
    //    } else {
    //        $("#VmDetail_AbfallVerwertungId").removeAttr("required");
    //    }
    //}

    //private changeAuftragnehmerAbweichende(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
    //    this.log("changeAbfall");
    //    this.updateAuftragnehmerControl();
    //}

    //private updateAuftragnehmerControl() {
    //    const abweichend = $("#VmDetail_AuftragnehmerAbweichend").is(":checked");

    //    if (abweichend) {
    //        $("#VmDetail_AuftragnehmerId").prop("required", "required");
    //        $("#VmDetail_AuftragnehmerId").removeAttr("disabled");
    //    }
    //    else {
    //        $("#VmDetail_AuftragnehmerId").removeAttr("required");
    //        $("#VmDetail_AuftragnehmerId").prop("disabled", "disabled");
    //    }
    //}

    //protected clickDetailRow(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
    //    super.clickDetailRow(e);

    //    const action = $(e.currentTarget).closest("div.erz-list").data("guiaktion");
    //    const id = $(e.currentTarget).closest("div.erz-list-element").data("id");

    //    this.log(`${action} ${id}`);
    //    $("#GuiAktion").val(action);
    //    $("#GuiAktionId").val(id);
    //    $("#detailForm").submit();
    //}

    changeEntsorgungsnachweis(): void {
        this.log("changeEntsorgungsnachweis");
        this.setBefoerderer();
    }

    setBefoerderer() {
        this.log("setBefoerderer");
        const option = $("#VmDetail_EntsorgungsnachweisId option:selected");
        let befId = option.data("data1") as string;
        this.log("Bef aus EN befId=" + befId);
        if (befId != null && befId !== "") {
            befId = befId.toUpperCase();
            $("#VmDetail_BefoerdererId").val(befId);
            $("#VmDetail_BefoerdererId").attr("disabled", "disabled");
        } else {
            $("#VmDetail_BefoerdererId").removeAttr("disabled");
        }
    }
}
